import { useTranslation } from 'react-i18next';
import React, {useState} from 'react';
import { TextField, Card, CardContent, Button, Box, Typography, Grid, Chip } from "@mui/material";
import {useSessionStorage} from '../../utils/hooks';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import ectoollogo from '../../assets/images/ectool_Logo_2019.png';
import apiRequest from '../../functions/api';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import { useAuth } from '../../context/auth-context';
import ReplayIcon from '@mui/icons-material/Replay';
import {useMessage} from '../../context/message-context';
export default () => {
  const [activationCode, setActivationCode] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [accessToken, ] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const {user} = useAuth();
  const {showSuccessMessage, showErrorMessage} = useMessage();
  const { t } = useTranslation();
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const activateCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      window.location.reload();
    } else {
      setError(response.data.message);
    }
  }
  
  const resendCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      showSuccessMessage(t("Der Aktivierungscode wurde erneut versendet."));
    } else {
      showErrorMessage(response.data.message);
    }
  }
  
  const handleResendCodeClick = (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('GET', 'resend-code', null, headers, resendCb);
  }
  const handlePasswordSubmitClick = (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    const payload={
      "activationCode": activationCode,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'activate-device', payload, headers, activateCb);
  }
  if (user.admincode === "J" && (user.mail !== "" || user.mail2 !== "")) {
    return(
      <Box p={2}>
        <Grid container >
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8} md={6}>
                <Card >
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <img src={ectoollogo} height="50" alt="ectool" loading="lazy"/>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5">{t("Neues Gerät aktivieren")}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Bitte geben Sie Ihren E-Mail-Aktivierungscode oder Admincode ein.")}</Typography>
                      </Grid>
                      {(user.mail !== "" && user.mail2 !== "") &&
                      <Grid item xs={12}>
                        <Typography variant="body1">Der Aktivierungscode wurde gesendet an {user.mail} und {user.mail2}</Typography>
                      </Grid>
                      }
                      {(user.mail !== "" && user.mail2 === "") &&
                      <Grid item xs={12}>
                        <Typography variant="body1">Der Aktivierungscode wurde gesendet an {user.mail}</Typography>
                      </Grid>
                      }
                      {(user.mail === "" && user.mail2 !== "") &&
                      <Grid item xs={12}>
                        <Typography variant="body1">Der Aktivierungscode wurde gesendet an {user.mail2}</Typography>
                      </Grid>
                      }
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Gerätekennung: ")}<Chip label={user.deviceConnection} /></Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Geben Sie Ihren Aktivierungscode ein, um das Gerät freizuschalten.")}</Typography>
                      </Grid>
                    </Grid>
                    <form>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12}>
                          <TextField 
                            type={showPassword ? "text":"password"}
                            fullWidth
                            error={error}
                            helperText={error}
                            label={t("Aktivierungscode")}
                            variant="outlined"  
                            id="password"
                            placeholder="Code eingeben ..."
                            value={activationCode}
                            onChange={(e) => setActivationCode(e.target.value)}
                            InputProps={{
                              autoFocus: true,
                              endAdornment: 
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                                </InputAdornment>
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            color="primary"
                            onClick={handleResendCodeClick}
                            fullWidth                            
                            endIcon={<ReplayIcon/>}
                          >Code erneut senden</Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={handlePasswordSubmitClick}
                            type="submit"
                            fullWidth
                          >aktivieren</Button>
                        </Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
                <Box p={1}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Box pt={1}>
                        <Button
                          type="button"
                          color="primary"
                          fullWidth
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://docs.ectool.de/app/verifizieren/#mitadmincodebesttigen"
                        >Wo finde ich meinen Admincode?</Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    )  
  }
  if (user.admincode === "J") {
    return(
      <Box p={2}>
        <Grid container >
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8} md={6}>
                <Card >
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <img src={ectoollogo} height="50" alt="ectool" loading="lazy"/>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5">{t("Neues Gerät aktivieren")}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Um Ihren Account zu schützen müssen Sie neue Geräte vor der ersten Verwendung mit dem Admincode aktivieren.")}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Gerätekennung: ")}<Chip label={user.deviceConnection} /></Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Geben Sie Ihren Admincode ein, um das Gerät zu aktivieren.")}</Typography>
                      </Grid>
                    </Grid>
                    <form>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12}>
                          <TextField 
                            type={showPassword ? "text":"password"}
                            fullWidth
                            error={error}
                            helperText={error}
                            label={t("Admincode")}
                            variant="outlined"  
                            id="password"
                            placeholder="Code eingeben ..."
                            value={activationCode}
                            onChange={(e) => setActivationCode(e.target.value)}
                            InputProps={{
                              autoFocus: true,
                              endAdornment: 
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                                </InputAdornment>
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={handlePasswordSubmitClick}
                            type="submit"
                            fullWidth
                          >aktivieren</Button>
                        </Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
                <Box p={1}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Box pt={1}>
                        <Button
                          type="button"
                          color="primary"
                          fullWidth
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://docs.ectool.de/app/verifizieren/#miteinmalcodebesttigen"
                        >Wo finde ich meinen Admincode?</Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    )  
  }
  if (user.mail !== "" || user.mail2 !== "") {
    return(
      <Box p={2}>
        <Grid container >
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8} md={6}>
                <Card >
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <img src={ectoollogo} height="50" alt="ectool" loading="lazy"/>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5">{t("Neues Gerät aktivieren")}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Um Ihren Account zu schützen müssen Sie neue Geräte vor der ersten Verwendung mit einem Code aktivieren.")}</Typography>
                      </Grid>
                      {(user.mail !== "" && user.mail2 !== "") &&
                      <Grid item xs={12}>
                        <Typography variant="body1">Der Aktivierungscode wurde gesendet an {user.mail} und {user.mail2}</Typography>
                      </Grid>
                      }
                      {(user.mail !== "" && user.mail2 === "") &&
                      <Grid item xs={12}>
                        <Typography variant="body1">Der Aktivierungscode wurde gesendet an {user.mail}</Typography>
                      </Grid>
                      }
                      {(user.mail === "" && user.mail2 !== "") &&
                      <Grid item xs={12}>
                        <Typography variant="body1">Der Aktivierungscode wurde gesendet an {user.mail2}</Typography>
                      </Grid>
                      }
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Gerätekennung: ")}<Chip label={user.deviceConnection} /></Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">{t("Geben Sie Ihren Aktivierungscode ein, um das Gerät zu aktivieren.")}</Typography>
                      </Grid>
                    </Grid>
                    <form>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12}>
                          <TextField 
                            type={showPassword ? "text":"password"}
                            fullWidth
                            error={error}
                            helperText={error}
                            label={t("Aktivierungscode")}
                            variant="outlined"  
                            id="password"
                            placeholder="Code eingeben ..."
                            value={activationCode}
                            onChange={(e) => setActivationCode(e.target.value)}
                            InputProps={{
                              autoFocus: true,
                              endAdornment: 
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                                </InputAdornment>
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            color="primary"
                            onClick={handleResendCodeClick}
                            fullWidth
                            endIcon={<ReplayIcon/>}
                          >Code erneut senden</Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={handlePasswordSubmitClick}
                            type="submit"
                            fullWidth
                          >aktivieren</Button>
                        </Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
                <Box p={1}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Box pt={1}>
                        <Button
                          type="button"
                          color="primary"
                          fullWidth
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://docs.ectool.de/app/verifizieren/#miteinmalcodebesttigen"
                        >Wo finde ich meinen Aktivierungscode?</Button>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box pt={1}>
                        <Button
                          type="button"
                          color="primary"
                          fullWidth
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://docs.ectool.de/app/verifizieren/#miteinmalcodebesttigen"
                        >Ich habe keinen Aktivierungscode bekommen.</Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    )
  }
  return(
    <Box p={2}>
      <Grid container >
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} sm={8} md={6}>
              <Card >
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <img src={ectoollogo} height="50" alt="ectool" loading="lazy"/>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5">{t("Neues Gerät aktivieren")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">{t("Um Ihren Account zu schützen, müssen neue Geräte vor der ersten Verwendung aktiviert werden.")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">{t("Da Sie keine Mail hinterlegt haben und noch keinen Admincode besitzen, muss Ihre Personalabteilung das Gerät freischalten.")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">{t("Dafür melden Sie sich mit der folgenden Gerätekennung: ")}<Chip label={user.deviceConnection}/>{t(" bei Ihrer Personalabteilung.")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">Benutzer: {user.name}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">Gerätekennung: {user.deviceConnection}</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Box p={2}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Button
                        type="button"
                        color="primary"
                        fullWidth
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://docs.ectool.de/app/verifizieren/#miteinmalcodebesttigen"
                      >Wo finde ich meinen Aktivierungscode?</Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}
